<template>
  <div class="newcomer-task">
    <header>
      <div>
        <span>新手玩家</span>
        <strong>新人基础任务</strong>
        <p>完成账号基础资料，为后续充值、活动与饰品取回做好准备。</p>
      </div>
      <div class="progress-ring">
        <strong>{{ completed }}/{{ total }}</strong>
        <span>已完成 · 已领 {{ claimed }}</span>
      </div>
    </header>
    <div class="task-list">
      <article v-for="item in tasks" :key="item.key" :class="item.state">
        <div class="task-index">{{ taskIndex(item) }}</div>
        <div class="task-copy">
          <strong>{{ item.title }}</strong>
          <p>{{ item.description }}</p>
          <em v-if="item.remark">驳回原因：{{ item.remark }}</em>
        </div>
        <div class="task-reward">
          <span>奖励</span>
          <strong>{{ item.reward_amount }} {{ item.reward_currency_name }}</strong>
        </div>
        <button
          v-if="item.claimable"
          class="claim-btn"
          :disabled="claimingKey == item.key"
          @click="claimReward(item)"
        >
          {{ claimingKey == item.key ? "领取中" : "领取奖励" }}
        </button>
        <button
          v-else-if="item.action_path && (item.state == 'incomplete' || item.state == 'rejected')"
          @click="goTask(item)"
        >
          {{ item.status_name }}
        </button>
        <span v-else class="task-state">{{ item.claimed ? "已领取" : item.status_name }}</span>
      </article>
    </div>
  </div>
</template>

<script>
import Utils from "../../../assets/js/util.js";
import { playUiSound } from "@/utils/pizzaSound";

export default {
  data() {
    return {
      completed: 0,
      claimed: 0,
      total: 4,
      tasks: [],
      claimingKey: "",
    };
  },
  created() {
    this.loadTasks();
  },
  activated() {
    this.loadTasks();
  },
  methods: {
    async loadTasks() {
      const { data } = await this.$axios.post(
        "/index/User/newcomerTasks",
        this.$qs.stringify({})
      );
      if (data.status == 1) {
        this.completed = data.data.completed;
        this.claimed = data.data.claimed;
        this.total = data.data.total;
        this.tasks = data.data.tasks;
      }
    },
    taskIndex(item) {
      return String(this.tasks.findIndex((task) => task.key == item.key) + 1).padStart(2, "0");
    },
    goTask(item) {
      this.$router.push(item.action_path);
    },
    async claimReward(item) {
      if (!item.claimable || this.claimingKey) {
        return;
      }
      this.claimingKey = item.key;
      const { data } = await this.$axios.post(
        "/index/User/claimNewcomerReward",
        this.$qs.stringify({ task_key: item.key })
      );
      this.claimingKey = "";
      if (data.status == 1) {
        playUiSound("reward");
        this.$message.success(data.msg || "领取成功");
        if (data.data && data.data.cheese_coin !== undefined) {
          this.$store.commit("getCheese", data.data.cheese_coin);
          Utils.$emit("cheese", data.data.cheese_coin);
        }
        if (data.data && data.data.special_key_balance !== undefined) {
          Utils.$emit("special-key", data.data.special_key_balance);
        }
        if (data.data && data.data.tasks) {
          this.completed = data.data.tasks.completed;
          this.claimed = data.data.tasks.claimed;
          this.total = data.data.tasks.total;
          this.tasks = data.data.tasks.tasks;
        } else {
          this.loadTasks();
        }
      } else {
        this.$message.warning(data.msg || "领取失败");
        this.loadTasks();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.newcomer-task {
  min-height: 420px;
  padding: 24px;
  color: #f5f7ff;
  background:
    radial-gradient(circle at 84% 8%, rgba(255, 138, 31, 0.16), transparent 30%),
    #242735;
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 14px;
}

header {
  padding: 4px 4px 22px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

header > div > span {
  color: #ff8a1f;
  font-size: 11px;
  font-weight: 1000;
  letter-spacing: 0.16em;
}

header > div > strong {
  margin-top: 7px;
  display: block;
  font-size: 26px;
  font-weight: 1000;
}

header p {
  margin: 8px 0 0;
  color: #9ea8bc;
  font-size: 13px;
}

.progress-ring {
  width: 92px;
  height: 92px;
  flex: 0 0 92px;
  display: grid;
  place-content: center;
  text-align: center;
  border: 7px solid rgba(255, 138, 0, 0.18);
  border-top-color: #ff9d19;
  border-radius: 50%;
}

.progress-ring strong {
  color: #ffd764;
  font-size: 20px;
}

.progress-ring span {
  color: #8e98ad;
  font-size: 10px;
}

.task-list {
  margin-top: 18px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.task-list article {
  min-height: 112px;
  padding: 16px;
  display: grid;
  grid-template-columns: 46px minmax(0, 1fr) 118px auto;
  gap: 14px;
  align-items: center;
  background: linear-gradient(180deg, #2b2e3d, #272a38);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 12px;
}

.task-list article.completed {
  border-color: rgba(40, 199, 111, 0.24);
}

.task-list article.rejected {
  border-color: rgba(234, 84, 85, 0.28);
}

.task-index {
  width: 46px;
  height: 46px;
  display: grid;
  place-items: center;
  color: #ffb32c;
  background: rgba(255, 138, 0, 0.1);
  border-radius: 12px 12px 12px 4px;
  font-weight: 1000;
}

.completed .task-index {
  color: #64e9a2;
  background: rgba(40, 199, 111, 0.1);
}

.task-copy strong {
  font-size: 15px;
}

.task-copy p,
.task-copy em {
  margin: 6px 0 0;
  display: block;
  color: #8993a8;
  font-size: 12px;
  font-style: normal;
  line-height: 1.55;
}

.task-copy em {
  color: #ff8f8f;
}

.task-reward {
  display: grid;
  gap: 5px;
  justify-items: end;
  white-space: nowrap;
}

.task-reward span {
  color: #8993a8;
  font-size: 11px;
  font-weight: 900;
}

.task-reward strong {
  color: #ffd764;
  font-size: 13px;
  font-weight: 1000;
}

button,
.task-state {
  min-width: 82px;
  height: 36px;
  padding: 0 13px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #151620;
  background: linear-gradient(180deg, #ffd53b, #ff8300);
  border: 0;
  border-radius: 7px;
  font-size: 12px;
  font-weight: 1000;
}

button:disabled {
  cursor: wait;
  opacity: 0.7;
}

.claim-btn {
  color: #151620;
  box-shadow: 0 12px 24px rgba(255, 131, 0, 0.2);
}

.task-state {
  color: #9ea8bc;
  background: rgba(255, 255, 255, 0.06);
}

.completed .task-state {
  color: #64e9a2;
  background: rgba(40, 199, 111, 0.1);
}

.pending .task-state {
  color: #ffd764;
  background: rgba(255, 159, 67, 0.1);
}

@media (max-width: 760px) {
  .newcomer-task { padding: 16px; }
  header { align-items: flex-start; }
  .task-list { grid-template-columns: 1fr; }
  .task-list article { grid-template-columns: 40px minmax(0, 1fr); }
  .task-index { width: 40px; height: 40px; }
  .task-reward { grid-column: 1 / -1; justify-items: start; }
  button, .task-state { grid-column: 1 / -1; width: 100%; min-height: 44px; }
}
</style>
